import {useMemo, useState} from 'react';

import {DateTime} from 'luxon';

import {DashboardStatData} from 'components/v2/app/dashboard/models';
import {createSeries} from 'components/v2/charts/AreaChart';
import {ActiveLabel} from 'components/v2/Labels';
import {Chart} from 'components/v3/Chart';

export const OverviewRevenueChartRaw = ({
  stats,
  period,
  height,
  chartOpts,
}: {
  stats?: DashboardStatData;
  period: string;
  height?: any;
  chartOpts?: any;
}) => {
  const currentData = stats?.[period as keyof typeof stats];
  const currentDataKeys = Object.keys(currentData || {});

  const sortedCurrentDataKeys = useMemo(
    () =>
      currentDataKeys.sort((a, b) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }),
    [currentDataKeys],
  );

  return (
    <div className="w-full ">
      <Chart
        chartOpts={chartOpts}
        labels={sortedCurrentDataKeys.map(i => {
          if (period === 'week') {
            // Extract the year and week number from the string
            const [year, weekNumber] = i.split('-W').map(Number);

            // Create a DateTime object representing the first day of the specified week
            const firstDayOfWeek = DateTime.fromObject({
              weekNumber,
              weekYear: year,
            })
              .startOf('week')
              .toISODate();

            return firstDayOfWeek || i;
          }

          return i;
        })}
        height={height}
        data={[
          createSeries(
            'Revenue',
            sortedCurrentDataKeys.map(
              i => currentData?.[i]?.revenue.toFixed(2) || 0,
            ),
          ),
        ]}
      />
    </div>
  );
};

export const OverviewRevenueChart = ({
  stats,
  chartOpts,
}: {
  stats: DashboardStatData;
  chartOpts?: any;
}) => {
  const [period, setPeriod] = useState<string>('day');
  return (
    <>
      <div className="flex flex-row mt-2">
        <h1 className="w-1/2 text-[16px] font-bold leading-9 ">
          {period === 'day' && `Daily revenue`}
          {period === 'week' && `Weekly revenue`}
          {period === 'month' && `Monthly revenue`}
          {period === 'year' && `Yearly revenue`}
        </h1>
        <div className="flex justify-end w-full gap-4 cursor-pointer">
          <ActiveLabel
            active={period === 'day'}
            onClick={() => setPeriod('day')}>
            Daily
          </ActiveLabel>
          <ActiveLabel
            active={period === 'week'}
            onClick={() => setPeriod('week')}>
            Weekly
          </ActiveLabel>
          <ActiveLabel
            active={period === 'month'}
            onClick={() => setPeriod('month')}>
            Monthly
          </ActiveLabel>
          <ActiveLabel
            active={period === 'year'}
            onClick={() => setPeriod('year')}>
            Yearly
          </ActiveLabel>
        </div>
      </div>
      <div className="flex flex-1 w-full h-full">
        <OverviewRevenueChartRaw
          period={period}
          stats={stats}
          chartOpts={chartOpts}
        />
      </div>
    </>
  );
};
